
import React from "react";
import "./footer.scss";
import { Send } from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer !py-8 lg:!py-10">
      <div className="footer-container">
        {/* Thông tin bên trái */}
        <div className="footer-info">
          <h3 className="!text-lg lg:!text-xl font-semibold">CỔNG THÔNG TIN ĐIỆN TỬ TỔNG CÔNG TY HẠ TẦNG MẠNG</h3>
          <div className="flex flex-col gap-1">
            <p className="!text-xs lg:!text-sm">Cơ quan chủ quản: <b>Tổng Công ty Hạ tầng mạng</b></p>
            <p className="!text-xs lg:!text-sm">Website: <a href="https://vnptnet.vn" target="_blank"><b>www.vnptnet.vn</b></a></p>
            <p className="!text-xs lg:!text-sm">Địa chỉ: Số 30, đường Phạm Hùng, phường Từ Liêm, thành phố Hà Nội</p>
            <p className="!text-xs lg:!text-sm">Điện thoại: <b>+84-24 37877777</b> - Fax: <b>+84-24 37876600</b> - <b>vnptnet@vnpt.vn</b></p>
          </div>
        </div>

        {/* Đăng ký nhận tin bên phải */}
        <div className="footer-subscribe">
          <label htmlFor="newsletter">Đăng ký nhận bản tin</label>
          <div className="subscribe-box">
            <input type="email" id="newsletter" placeholder="Nhập email của bạn..." />
            <button>
              <Send size={18} color="white" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
